var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading || !_vm.previewImageBlob)?_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',[(_vm.panorama?.is360Image)?_c('div',{style:({
			'--bearing': _vm.bearing,
			'--elem-center-offset': '-295px',
			backgroundImage: `url(${_vm.URL.createObjectURL(_vm.previewImageBlob)})`,
			height: '200px',
			backgroundSize: '2000px',
			backgroundPositionY: 'center',
			backgroundPositionX: 'calc(((var(--bearing) / -360) * 2000px) - var(--elem-center-offset))',
			backgroundRepeat: 'repeat-x',
			cursor: 'pointer'
		}),on:{"click":function($event){_vm.$emit('openPanoramaDialog', _vm.bearing.toFixed(0))}}}):(_vm.panorama?.is360Image === false)?_c('div',{style:({
			backgroundImage: `url(${_vm.URL.createObjectURL(_vm.previewImageBlob)})`,
			height: '200px',
			backgroundPosition: 'center',
			backgroundSize: 'cover'
		})}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }